import React from 'react'
import { Box, Chip, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Show.layout = (page) => <AppShell>{page}</AppShell>

export default function Show({ property, generator, receivables = [] }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title={`Sollstellung: ${generator.receivable_type_name || ''}`}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Sollstellungen', href: `${basePath}/receivables` },
          { label: generator.receivable_type_name || `#${generator.id}` },
        ]}
      />

      <Paper elevation={0} sx={{ p: 2, mb: 2, border: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">Einheit: {generator.unit_number}</Typography>
          <Typography variant="body2" color="text.secondary">
            Betrag: <FormattedCurrency value={generator.amount} align="left" />
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Gültig ab: {generator.valid_from}
          </Typography>
          {generator.valid_until && (
            <Typography variant="body2" color="text.secondary">
              Gültig bis: {generator.valid_until}
            </Typography>
          )}
          <Chip label={generator.recurring ? 'Wiederkehrend' : 'Einmalig'} size="small"
            color={generator.recurring ? 'primary' : 'default'} variant="outlined" />
        </Box>
      </Paper>

      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        Forderungen ({receivables.length})
      </Typography>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Periode</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Fällig</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Betrag</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Zugeordnet</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Offen</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {receivables.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Forderungen vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {receivables.map((r) => (
              <TableRow key={r.id} data-testid={`receivable-row-${r.id}`}>
                <TableCell>{String(r.period_month).padStart(2, '0')}/{r.period_year}</TableCell>
                <TableCell>{r.due_date}</TableCell>
                <TableCell align="right"><FormattedCurrency value={r.billable_amount} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={r.allocated_amount} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={r.open_amount} /></TableCell>
                <TableCell>
                  <Chip
                    label={r.paid ? 'Bezahlt' : 'Offen'}
                    size="small"
                    color={r.paid ? 'success' : 'warning'}
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
